module.exports = __webpack_public_path__ + "static/media/car.d2337dc6.png";